import React, { useState, useEffect } from 'react';
import SozialUndBerufsanamnese from './SozialUndBerufsanamnese';
import { useDispatch, useSelector } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'
import { Offcanvas, Container, Spinner } from 'react-bootstrap';
import { Button } from '@aws-amplify/ui-react'
import { MdSave, MdDoneOutline } from 'react-icons/md'
import { SozUndArbeitsAnamneseLeer } from './SozUndArbeitsAnamneseLeer';
import { updateData } from '../lib/updateData';
import { readData } from '../lib/readData';

const Loading = (props) => {
    return (
        <Spinner animation="boarder" role="status">
            <span className="visually-hidden">Loading {props.loadingtext}...</span>
        </Spinner>
    )
}

const Anamnese = (props) => {
    const [user] = useState(props.authenticated);
    const dispatch = useDispatch()
    const daten = useSelector(state => state.anamnese.Daten);
    const [sticky, setSticky] = useState(undefined);
    const [show, setShow] = useState(false);
    const [hasError, setHasError] = useState({});
    const [error, setError] = useState();
    const [saved, setSaved] = useState(null);

    // console.log("hasError", Object.keys(hasError).find(key => hasError[key] === true))
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSaveButton = (e) => {
        const newData = { SozUBeruf: { ...daten }, User: user.username };
        updateData('SozUBeruf.txt', { ...newData, MASSNID: props.massnid });
        // console.log(daten, newData)
        storeDaten(newData);
        setSaved(setTimeout(() => {
            setSaved(null);
        }, 1000))
    }

    function handleChange(value) {
        if (!props.readOnly)
            setSticky(true);
    }

    function MyFallbackComponent({ error, resetErrorBoundary }) {
        return (
            <div role="alert">
                <p>Something went wrong:</p>
                <pre>{error.message}</pre>
                <button onClick={resetErrorBoundary}>Try again</button>
            </div>
        )
    }

    const storeDaten = (data) => {
        const newData = { ...SozUndArbeitsAnamneseLeer.SozUBeruf, ...data.SozUBeruf }
        dispatch({ type: 'anamnese/DatenReplaced', payload: newData });
        // console.log('setting new data to', newData);
        setSticky(false);
    }

    //    useBlocker("Are you sure you want to leave?", sticky);   // wait for version 6 is completed and useBlocker back
    useEffect(() => {
        window.onbeforeunload = function () {
            if (sticky) {
                return "Sie haben nicht gespeicherte Änderungen?";
            }
        };
    }, [sticky]);

    useEffect(() => {
        if (!daten || !daten.VERSION) {
            //    if (props.massnid)
            readData(props.massnid, storeDaten)
        }
        return () => {
            // console.log('leaving Anamnese');
            dispatch({ type: 'anamnese/DatenReplaced', payload: {} });
            if (saved != null) {
                clearTimeout(saved);
                setSaved(null);
            }
        }
        // console.log('useEffect called in Menues... isLoaded', daten, speiseplan, isLoaded)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (error) {
        // You can render any custom fallback UI
        return (<MyFallbackComponent error={error} />);
    }

    if (!props.massnid) {
        return (<p>&nbsp;&nbsp;&nbsp;Bitte erst einen Patienten auswählen...</p>);
    }

    return (
        <Container fluid>
            {!daten && <Loading loadingtext="Daten" />}
            {daten && daten.VERSION &&
                <>
                    <div
                        className="floating-div"
                        style={{
                            position: "fixed",
                            right: "10px",
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "0.5rem",
                            padding: "1rem",
                            zIndex: "50"
                        }}>
                        <Button style={{ backgroundColor: 'white'}} variant="light" onClick={handleShow}>Hilfe</Button>
                        {sticky &&
                            <Button
                                size='large'
                                gap="1rem"
                                type="submit"
                                variation="primary"
                                onClick={handleSaveButton}
                                isDisabled={Object.keys(hasError).find(key => hasError[key] === true)}
                            > <MdSave />&nbsp;Speichern</Button>
                        }
                        {saved && <Button
                            size='large'
                            gap="1rem"
                            variation="primary"
                        > <MdDoneOutline />&nbsp;gespeichert</Button>
                        }
                    </div>
                    <Offcanvas show={show} onHide={handleClose}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Erläuterungen</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <p>Um Sie optimal behandeln zu können, benötigen wir auch Daten zu Ihrem sozialen, arbeitstechnischen und beruflichen Umfeld.</p>
                            <p>Diese Daten erheben wir, speichern sie in unserem Verwaltungssystem und geben sie, nur mit Ihrem Einverständnis, an nachbehandelnde Stellen weiter.</p>
                        </Offcanvas.Body>
                    </Offcanvas>
                    <ErrorBoundary
                        FallbackComponent={MyFallbackComponent}
                        onError={(error, errorInfo) => {
                            console.error({ error, errorInfo });
                            setError(error);
                        }}
                        onReset={() => {
                            // reset the state of your app
                            setError(false);
                        }}
                    >
                        <SozialUndBerufsanamnese
                            onChange={handleChange}
                            key='dummy'
                            defaultNation={39}
                            rentner={daten.RENTE}
                            setHasError={setHasError}
                            hasError={hasError}
                            readOnly={props.readOnly}
                        />
                    </ErrorBoundary>
                </>
            }
        </Container>
    )
}

export default Anamnese;